var l={profileBlock:"lds-profile-block",labels:"lds-profile-block--labels",subtitle:"lds-profile-block--subtitle",title:"lds-profile-block--title",avatar:"lds-profile-block--avatar"};export{l as default};
